import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link, useNavigate } from 'react-router-dom';
import { carsAPI } from '../services/api';
import SparePartsGrid from '../components/SparePartsGrid';
import './SpareParts.css';

const areaLabels = { front: 'أمامي', rear: 'خلفي', side: 'جانبي', interior: 'الداخلية' };
const AREA_OPTIONS = [
  { value: 'front', label: 'أمامي' },
  { value: 'rear', label: 'خلفي' },
  { value: 'side', label: 'جانبي' },
  { value: 'interior', label: 'الداخلية' },
];

const SpareParts = () => {
  const { area } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const variantId = searchParams.get('variant');
  const category = searchParams.get('category'); // 'accessories' | 'parts'
  const [variant, setVariant] = useState(null);
  const [loadingVariant, setLoadingVariant] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [area, variantId]);

  useEffect(() => {
    if (!variantId) {
      setVariant(null);
      return;
    }
    setLoadingVariant(true);
    carsAPI
      .getVariant(variantId)
      .then((res) => setVariant(res.data))
      .catch(() => setVariant(null))
      .finally(() => setLoadingVariant(false));
  }, [variantId]);

  const areaLabel = areaLabels[area] || area;
  const query = new URLSearchParams();
  if (variantId) query.set('variant', variantId);
  if (category) query.set('category', category);
  const queryString = query.toString();

  const carImageByArea =
    variant &&
    (area === 'front'
      ? variant.image_front_url || variant.image_url
      : area === 'rear'
        ? variant.image_rear_url || variant.image_url
        : area === 'side'
          ? variant.image_side_url || variant.image_url
          : area === 'interior'
            ? variant.image_interior_url || variant.image_url
            : variant.image_url);

  // تحميل صور المناطق الثلاث مسبقاً لظهور فوري عند التبديل
  useEffect(() => {
    if (!variant) return;
    const urls = [
      variant.image_front_url || variant.image_url,
      variant.image_rear_url || variant.image_url,
      variant.image_side_url || variant.image_url,
      variant.image_interior_url || variant.image_url,
      variant.image_url,
    ].filter(Boolean);
    const unique = [...new Set(urls)];
    unique.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }, [variant]);

  return (
    <div className="spare-parts-page">
      <div className="parts-page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/" className="breadcrumb-link">الرئيسية</Link>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">{category === 'accessories' ? 'كماليات' : 'قطع الغيار'}{areaLabel ? ` — ${areaLabel}` : ''}</span>
          </div>
          <h1 className="page-title">{category === 'accessories' ? 'الكماليات المتاحة' : 'قطع الغيار المتاحة'}{areaLabel ? ` (${areaLabel})` : ''}</h1>
          <p className="page-subtitle">
            {category === 'accessories'
              ? 'اختر الكمالية التي تحتاجها واتصل بنا عبر واتساب'
              : 'اختر القطعة التي تحتاجها واتصل بنا عبر واتساب للحصول على أفضل الأسعار'}
          </p>
        </div>
      </div>
      
      <div className="container">
        {variantId && (
          <div className="parts-car-image-section">
            {loadingVariant ? (
              <div className="parts-car-image-placeholder">
                <div className="spinner" aria-hidden="true" />
                <span>جاري تحميل صورة السيارة...</span>
              </div>
            ) : carImageByArea ? (
              <div className="parts-car-image-wrap">
                <img
                  key={area}
                  src={carImageByArea}
                  alt={`${variant?.model?.name || variant?.model_name || ''} ${variant?.name || ''} - عرض ${areaLabel}`}
                  className="parts-car-image"
                />
              </div>
            ) : null}
          </div>
        )}
        <div className="area-filters-wrap">
          <div className="area-filters" role="group" aria-label="فلتر المنطقة">
            {AREA_OPTIONS.map((o) => (
              <button
                key={o.value}
                type="button"
                className={`area-filter-btn ${area === o.value ? 'active' : ''}`}
                onClick={() => navigate(`/parts/${o.value}${queryString ? `?${queryString}` : ''}`, { replace: true })}
              >
                {o.label}
              </button>
            ))}
          </div>
        </div>
        {!variantId ? (
          <div className="parts-select-car-hint">
            <p>يرجى اختيار السيارة من الصفحة الرئيسية لعرض {category === 'accessories' ? 'الكماليات' : 'قطع الغيار'}.</p>
            <Link to="/" className="btn btn-primary">الذهاب للرئيسية</Link>
          </div>
        ) : (
          <SparePartsGrid area={area} variantKey={variantId} variant={variant} category={category} />
        )}
      </div>
    </div>
  );
};

export default SpareParts;
